import HttpService from './HttpService';
import { getUrlConfigApi, translate, showMessageToastCustom, getApiKeyLogistics } from '../utils/util';
import { startLoading, endLoading } from '../actions/loadingAction';
import * as justificationAction from '../actions/justificationAction';

const httpService = new HttpService(getUrlConfigApi(window), getApiKeyLogistics(window));
export default class JustificationService {
    static getJustifications(vision, filter, pagination, disableLoading) {
        filter.vision = vision;
        Object.assign(filter, pagination);
        const url = '/justification';
        return (dispatch) => {
            if (navigator.onLine) {
                if (!disableLoading) {
                    dispatch(startLoading());
                }
                httpService.instance.get(
                    url,
                    {
                        params: filter,
                        timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT,
                        timeoutErrorMessage: translate('general.timeout')
                    }
                ).then((response) => {
                    if (response.status === 200) {
                        dispatch(justificationAction.setJustifications(response.data));
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static AddJustification = (justification, callback) => {
        const url = '/justification';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.post(url, justification, { timeout: 360000, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 201) {
                        if (callback) {
                            callback(response.data);
                        }
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), response?.data?.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static PutJustification = (justification, callback) => {
        const url = '/justification';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url, justification, { timeout: 360000, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        if (callback) {
                            callback(response.data);
                        }
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), response?.data?.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static DeleteJustification = (justificationId, callback) => {
        const url = '/justification';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.delete(`${url}/${justificationId}`, { timeout: 360000, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 204) {
                        showMessageToastCustom(translate('warning', 'general'), translate('failed-to-delete', 'general'), 3000, 'mdi mdi-alert-circle-outline red-text');

                    } else {
                        showMessageToastCustom(translate('warning', 'general'), response?.data?.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                    if (callback) {
                        callback();
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static getJustificationsType() {
        const url = '/justificationtype';
        return (dispatch) => {
            if (navigator.onLine) {
                httpService.instance.get(url, { timeout: 360000, timeoutErrorMessage: translate('general.timeout') }
                ).then((response) => {
                    if (response.status === 200) {
                        dispatch(justificationAction.setJustificationsType(response.data));
                    }
                }).catch((error) => {
                    return error;
                })
            }
        };
    }
}
